import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import CountUp from "react-countup";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions";
// import { useModules } from 'co/modules';
import { DASHBOARD } from "common/viewContent";
import PractitionerSignupChart from "./Component/PractitionerSignupChart";
import SubscriptionPieChart from "./Component/SubscriptionPieChart";
import ClientSignupChart from "./Component/ClientSignupChart";
import { dashboardInfo } from "store/services/profileService";
import PractitionerListing from "./Component/PractitionerListing";
import Dashboards from "./Dashboards";
const Dashboard = ({
  dispatch,
  practCount,
  clientCounts,
  clientCharts,
  practCharts,
  latestPract,
  subscriptionChart,
}) => {

  useEffect(() => {
    getDashboardInfo();
  }, []);

  const getDashboardInfo = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      await dispatch(dashboardInfo());
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log("Error fetching dashboard data", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }
  return (
    <>
      <Dashboards />
      <Helmet title={DASHBOARD.CURRENT_MODULE} />
      <section className="section mt-5">
        <div className="section-header">
          <h1>{DASHBOARD.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <Link to={"/admin/new-page"}><div className="breadcrumb-item">Dashboard</div></Link>
          </div>
        </div>
        <div className="row CounterCards">
          <div className="col-lg-4 col-sm-6 my-2">
            <div className="h-100 p-3 card-statistic-2 cardBox mb-0">
              <div className="card-stats">
                <div className="card-stats-title">
                  <div className="row">
                    <div className="col-md-7 content">
                      <h6>Welcome Back ! </h6>
                    </div>
                    <div className="col-md-5">
                      <Link to={Path.profile}>
                        <button className="btn btn-sm btn-primary">
                          Update Profile
                        </button>
                      </Link>
                    </div>
                  </div>
                  <p className="m-0">Dashboard</p>
                </div>
                <div className="card-wrap"></div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6 my-2">
            <div className="cardBox d-flex align-items-start gap-10 p-3 h-100">
              <div
                className="imgWrp d-flex align-items-center justify-content-center rounded-pill"
                style={{ background: "#F18D06" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.7896 15.6C14.9406 15.2602 14.6016 14.3265 14.6016 14.3265C14.6016 14.3265 14.2191 14.538 14.2191 13.944C14.2191 13.35 14.6016 14.3265 14.9841 12.033C14.9841 12.033 16.0439 11.7352 15.8316 9.27298H15.5766C15.5766 9.27298 16.2141 6.64048 15.5766 5.74798C14.9391 4.85698 14.6856 4.26298 13.2839 3.83773C11.8821 3.41248 12.3929 3.49723 11.3736 3.54073C10.3536 3.58423 9.50461 4.13548 9.50461 4.43323C9.50461 4.43323 8.86711 4.47523 8.61361 4.73023C8.35861 4.98523 7.93411 6.17323 7.93411 6.47023C7.93411 6.76723 8.14636 8.76523 8.35861 9.18898L8.10585 9.27448C7.89285 11.7367 8.95336 12.0345 8.95336 12.0345C9.33586 14.328 9.71836 13.3515 9.71836 13.9455C9.71836 14.5395 9.33586 14.328 9.33586 14.328C9.33586 14.328 8.99686 15.2617 8.14786 15.6015C7.29886 15.9405 2.58586 17.766 2.20261 18.1485C1.81861 18.531 1.86211 20.3145 1.86211 20.3145H22.0724C22.0724 20.3145 22.1174 18.5317 21.7334 18.1485C21.3509 17.766 16.6371 15.9405 15.7881 15.6015L15.7896 15.6ZM6.43711 15.471C6.36211 15.336 6.32611 15.2385 6.32611 15.2385C6.32611 15.2385 6.00211 15.4185 6.00211 14.9145C6.00211 14.4105 6.3261 15.2385 6.6501 13.2945C6.6501 13.2945 7.55011 13.0432 7.37011 10.956H7.15261C7.15261 10.956 7.2606 10.5135 7.3311 9.95548C7.32795 9.70617 7.33721 9.45687 7.35886 9.20848L7.38736 8.88898C7.37236 8.51998 7.30711 8.18398 7.15336 7.96948C6.61336 7.21423 6.39736 6.70948 5.21086 6.34948C4.02286 5.98948 4.45336 6.06148 3.59086 6.09823C2.72686 6.13573 2.00686 6.60223 2.00686 6.85573C2.00686 6.85573 1.46686 6.89098 1.25086 7.10698C1.04836 7.30948 0.722105 8.20348 0.683105 8.52073V8.73073C0.719105 9.22123 0.878105 10.5682 1.03561 10.8855L0.821105 10.9575C0.641105 13.044 1.54111 13.296 1.54111 13.296C1.86361 15.2385 2.18836 14.412 2.18836 14.916C2.18836 15.42 1.86436 15.2385 1.86436 15.2385C1.86436 15.2385 1.57711 16.032 0.857105 16.3185L0.683105 16.3875V20.313H1.11436C1.09186 19.3545 1.17211 18.1177 1.67386 17.6175C1.94161 17.3512 2.81686 16.9125 6.43861 15.471H6.43711ZM23.1846 8.67898C23.1546 8.39548 23.0894 8.14273 22.9656 7.96948C22.4271 7.21348 22.2104 6.70948 21.0231 6.34948C19.8359 5.98948 20.2679 6.06148 19.4031 6.09823C18.5406 6.13573 17.8206 6.60223 17.8206 6.85573C17.8206 6.85573 17.2806 6.89098 17.0646 7.10698C16.8621 7.31098 16.5321 8.21098 16.4961 8.52448H16.5209L16.5809 9.20998C16.5959 9.38248 16.5974 9.53623 16.6011 9.69298C16.6686 10.1925 16.7586 10.7055 16.8486 10.8855L16.6341 10.9567C16.4541 13.0432 17.3541 13.2952 17.3541 13.2952C17.6781 15.2377 18.0014 14.4112 18.0014 14.9152C18.0014 15.4192 17.6789 15.2377 17.6789 15.2377C17.6789 15.2377 17.6384 15.345 17.5559 15.4927C21.1334 16.9177 22.0011 17.3527 22.2659 17.6175C22.7684 18.1185 22.8464 19.3545 22.8246 20.3137H23.1846V16.335L23.1471 16.3185C22.4271 16.0312 22.1391 15.2385 22.1391 15.2385C22.1391 15.2385 21.8144 15.4185 21.8144 14.916C21.8144 14.4135 22.1391 15.2385 22.4624 13.296C22.4624 13.296 23.0654 13.1235 23.1846 11.916V10.995C23.1846 10.9815 23.1846 10.9702 23.1824 10.9575H22.9649C22.9649 10.9575 23.1269 10.29 23.1846 9.56098V8.67898Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="content">
                <h6 className="m-0 fw-bold mb-2">Total Practitioners</h6>
                <p className="m-0">
                  {practCount}
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6 my-2">
            <div className="cardBox d-flex align-items-start gap-10 p-3 h-100">
              <div
                className="imgWrp d-flex align-items-center justify-content-center rounded-pill"
                style={{ background: "#F18D06" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="content">
                <h6 className="m-0 fw-bold mb-2">Clients</h6>
                <p className="m-0">
                  {clientCounts}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row graphChartsWrpper">
          <div className="col-lg-8 my-2">
            <div className="cardBox p-3 px-lg-4 bg-white h-100">
              <div className="top border-bottom pb-3 mb-3">
                <h4 className="m-0 fw-sbold">Practitioner</h4>
              </div>
              <div className="graphWrp">
                <PractitionerSignupChart
                  data={practCharts}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 my-2">
            <div className="cardBox p-3 px-lg-4 bg-white h-100">
              <div className="top border-bottom pb-3 mb-3">
                <h4 className="m-0 fw-sbold">Subscription</h4>
              </div>
              <div className="graphWrp">
                <SubscriptionPieChart
                  data={subscriptionChart}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 my-2">
            <div className="cardBox p-3 px-lg-4 bg-white h-100">
              <div className="top border-bottom pb-3 mb-3">
                <h4 className="m-0 fw-sbold">Clients</h4>
              </div>
              <div className="graphWrp">
                <ClientSignupChart
                  data={clientCharts}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 my-2">
            <div className="cardBox p-3 px-lg-4 bg-white h-100">
              <div className="top border-bottom pb-3 mb-3">
                <h4 className="m-0 fw-sbold">Practitioners</h4>
              </div>
              <div className="table-responsive">
                <PractitionerListing
                  practitioners={latestPract}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  let {
    practCount,
    clientCounts,
    clientCharts,
    practCharts,
    latestPract,
    subscriptionChart,
  } = state.Profile.dashboardInfo;

  return {
    practCount,
    clientCounts,
    clientCharts,
    practCharts,
    latestPract,
    subscriptionChart,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
